/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef } from "react"
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"
import { LANDING_EDIT_MODE, SELECT_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingStore, useLandingConsoleStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import { getLandingContainer } from "../../utils/getLandingContainer"
import ContentEditBack from "./content-edit/ContentEditBack"
import ContentEditBreadcrumbs from "./content-edit/ContentEditBreadcrumbs"
import ContentEditChildren from "./content-edit/ContentEditChildren"
import { clearEdit } from "./content-edit/clearEdit"
import { editMeat } from "./content-edit/editMeat"
import Transformer from "./transformer/Transformer"

/* Protopia Ecosystem component */
export interface IContentDoubleClickFormProps {
   
}
const ContentDoubleClickForm = (props: IContentDoubleClickFormProps): JSX.Element => {
    const ref                       = useRef(null)
    const select                    = useSyncState<any>(null) 
    const selectEditContent         = useSyncState<DOMRect | null>(null)
    const doubleClickSectionID      = useLandingStore((state: ILandingStore) => state.doubleClickSectionID)
    const doubleClickDataID         = useLandingStore((state: ILandingStore) => state.doubleClickDataID)
    const doubleClickType           = useLandingStore((state: ILandingStore) => state.doubleClickType)

    const onScroll = () => {
        if(!!select.get())
            selectEditContent.set(( select.get().getBoundingClientRect() ))
    }

    const onClick = ( evt: any ) => {
        const meat          = evt.target.closest(".landing-section-container > .landing-data-components-container > .landing-section-data-animation > .landing-section-data-position > .landing-content-container:not(:has(.icon-square))") 
        const float         = evt.target.closest(".landing-section-container > .landing-floats-container .landing-float") 
        const title         = evt.target.closest(".landing-section-container > .landing-section-title-container") 
        const delimiter     = evt.target.closest(".landing-section-container > .landing-delimiter") 
        const background    = evt.target.closest(".landing-section-bg-color, .landing-section-bg-image") 
        const menus         = evt.target.closest(".landing-data-panel-btn")
        
        let section: any  
        if( !!meat ) { 
            evt.stopPropagation()
            evt.preventDefault() 
            select.set(meat)  
            selectEditContent.set(( select.get().getBoundingClientRect() ))
            section = select.get().closest(".landing-section-container.landing-gap[id]")
            const sectionId = section?.getAttribute("id") || ""
            const _id = select.get().getAttribute("data-content-id") || ""
            const type = select.get().getAttribute("data-type") || ""
            useLandingConsoleStore.setState({editMode: LANDING_EDIT_MODE.TRANSFORM})
            useLandingStore.setState({
                selectedMeat: _id, 
                selectedFloat: "", 
                selectedLayer: sectionId,
                selectedType: SELECT_TYPE.CONTENT,
            })

            useLandingStore.setState( { doubleClickSectionID : sectionId } )
            useLandingStore.setState({ doubleClickDataID: _id })
            useLandingStore.setState({ doubleClickType: SELECT_TYPE.CONTENT })
            editMeat( sectionId, _id, SELECT_TYPE.CONTENT )
            return
        }
        else if(!!menus) { 
            
        }
        else {  
            deselect()
        }
    }
    const deselect = () => {
        select.set(null)
        selectEditContent.set(null) 
        clearEdit()
    }
    useEffect(() => {
        const landing = getLandingContainer() 
        landing.addEventListener("scroll", onScroll)
        landing.addEventListener("dblclick", onClick)
        return () => { 
            landing.removeEventListener("scroll", onScroll)
            landing.removeEventListener("dblclick", onClick)
        }
    }, []) 
    
    return <div 
        className='landing-content-double-click-form'
        style={{
            top: selectEditContent.get()?.top,
            left: selectEditContent.get()?.left, 
            height: 0,
        }}
        ref={ ref }
    >
        <div 
            className="contour untouchble" 
            style={{
                top: 0,
                left: 0,
                width: selectEditContent.get()?.width,
                height: selectEditContent.get()?.height,
            }}
        />
        <ContentEditBreadcrumbs deselect={deselect} />
        <ContentEditBack />
        {/* <ContentEditChildren parent={(ref.current ) as Element | null} /> */}
    </div> 
}
export default ContentDoubleClickForm
